export const url = 'https://sso.mediabank.me';
